import { useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { serviceWizardSearchRequestService } from '../../services/api/serviceWizardSearchRequestService';
import { getWizardClientSessionId } from '../../utils/wizardClientSession';

/**
 * After login, links anonymous wizard search requests to the signed-in account.
 */
const WizardSessionLinker = () => {
  const { user, loading } = useAuth();
  const ranRef = useRef(false);

  useEffect(() => {
    if (loading || !user) return;
    if (ranRef.current) return;

    const clientSessionId = getWizardClientSessionId();
    if (!clientSessionId) return;

    ranRef.current = true;

    (async () => {
      try {
        const rows =
          await serviceWizardSearchRequestService.listByClientSessionId(
            clientSessionId,
          );
        for (const row of rows) {
          if (!row?.id) continue;
          await serviceWizardSearchRequestService.patchLinkToAccount(
            row.id,
            clientSessionId,
          );
        }
      } catch (e) {
        console.error('Wizard session link failed:', e);
        ranRef.current = false;
      }
    })();
  }, [user, loading]);

  return null;
};

export default WizardSessionLinker;
